export const createTestIsSecureContextSupport = (window) => {
    return () => window !== null && window.hasOwnProperty('isSecureContext');
};
//# sourceMappingURL=test-is-secure-context-support.js.map